<template>
  <div id="app">
    <div class="area-radar-chart">
      <div class="content-1" style="height: 250px;">
        <div class="chart-content-div-header">
          <h4><small><i class="glyphicon glyphicon-signal"></i>&nbsp;&nbsp;&nbsp; {{ title }}</small></h4>
        </div>

        <div class="chart-content-div">
          <highcharts :options="chartOptions" ref='chart' style='height: 100%;width: 100%;'></highcharts>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Vue from 'vue'

export default {
  name: 'donut',
  data () {
    return {
      tableData: [],
      chartOptions: {
        chart: {
          colors: ['#f45b5b', '#434348'],
          type: 'pie',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063',
          // margin: [-10, -10, -20, -10],
          margin: -5,
          marginTop: 20
        },
        title: {
          text: `${((this.pendente / (this.pendente + this.programado) || 0) * 100).toFixed(2)} %`,
          align: 'center',
          verticalAlign: 'middle',
          margin: -10,
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase',
            fontSize: '16px !important',
            fontWeight: 'bold !important',
          }
        },
        subtitle: {
          text: '',
          style: {
            color: '#E0E0E3',
            textTransform: 'uppercase'
          }
        },
        accessibility: {
          announceNewData: {
            enabled: true
          },
          point: {
            valueSuffix: '%'
          }
        },
        xAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        yAxis: {
          gridLineColor: '#707073',
          labels: {
            style: {
              color: '#E0E0E3'
            }
          },
          lineColor: '#707073',
          minorGridLineColor: '#505053',
          tickColor: '#707073',
          tickWidth: 1,
          title: {
            style: {
              color: '#A0A0A3'
            }
          }
        },
        tooltip: {
          headerFormat: '',
          formatter: function() {
            if(this.point.name == 'No data')
              return false
            return `<span style="color:${this.color}">${this.point.name}</span>: <b>${this.y}</b>`;
          },
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          style: {
            color: '#F0F0F0'
          }
        },
        plotOptions: {
          pie: {
            size: '80%',
            borderWidth: 0,
            borderColor: '#f45b5b',
            dataLabels: {
              distance: 5
            },
            startAngle: -180,
            endAngle: 180,
            center: ['50%', '50%'],
            cursor: 'pointer',
          },
          series: {
            innerSize: '50%',
            dataLabels: {
              enabled: true,
              color: '#F0F0F3',
              style: {
                fontSize: '13px'
              }
            },
            events:{
              click: this.loadGrid
            },
          },
          boxplot: {
            fillColor: '#505053'
          },
          candlestick: {
            lineColor: 'white'
          },
          errorbar: {
            color: 'white'
          }
        },
        legend: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          itemStyle: {
              color: '#E0E0E3'
          },
          itemHoverStyle: {
              color: '#FFF'
          },
          itemHiddenStyle: {
              color: '#606063'
          },
          title: {
            style: {
              color: '#C0C0C0',
              fontSize: '12px;'
            }
          }
        },
        credits: {
          style: {
            color: '#666'
          }
        },
        labels: {
          style: {
            color: '#000'
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            color: '#F0F0F3'
          },
          activeDataLabelStyle: {
            color: '#F0F0F3'
          }
        },
        navigation: {
          buttonOptions: {
            symbolStroke: '#DDDDDD',
            theme: {
              fill: '#505053'
            }
          }
        },
        // scroll charts
        rangeSelector: {
          buttonTheme: {
            fill: '#505053',
            stroke: '#000000',
            style: {
              color: '#CCC'
            },
            states: {
              hover: {
                fill: '#707073',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              },
              select: {
                fill: '#000003',
                stroke: '#000000',
                style: {
                  color: 'white'
                }
              }
            }
          },
          inputBoxBorderColor: '#505053',
          inputStyle: {
            backgroundColor: '#333',
            color: 'silver'
          },
          labelStyle: {
            color: 'silver'
          }
        },
        navigator: {
          handles: {
            backgroundColor: '#666',
            borderColor: '#AAA'
          },
          outlineColor: '#CCC',
          maskFill: 'rgba(255,255,255,0.1)',
          series: {
            color: '#7798BF',
            lineColor: '#A6C7ED'
          },
          xAxis: {
            gridLineColor: '#505053'
          }
        },
        scrollbar: {
          barBackgroundColor: '#808083',
          barBorderColor: '#808083',
          buttonArrowColor: '#CCC',
          buttonBackgroundColor: '#606063',
          buttonBorderColor: '#606063',
          rifleColor: '#FFF',
          trackBackgroundColor: '#404043',
          trackBorderColor: '#404043'
        },
        series: [
        {
          name: "Reports",
          colorByPoint: true,
          data: [
            {name: this.$t("297"), y: this.pendente, color: '#f45b5b'},
            {name: this.$t("298"), y: this.programado, color: '#e4d354'}
          ]
        }
        ],
        drilldown: {
          series: []
        },
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },
      },
    }
  },
  methods: {
    loadGrid(event){
      
      let area_id = '';
      let planta = ''; 
      let region = '';

      let evento = event.point.name
        let filtro = ''
        if(evento == 'Pendente'){
            filtro = 'Pending';
        }
        if(evento == 'Programado'){
            filtro = 'Scheduled';
        }
       
        let filter = !filtro ? event.point.name : filtro
        /*console.log('evento', evento)
        console.log('filter', filter)*/

      
      let feedback = filter

      let NAME_CHART = `${feedback.toUpperCase()} REPORTS - ${this.title}`;

      if (feedback == 'No data') return;

      if (this.filters.plant){
        planta = this.filters.plant;
        area_id = this.id;
      } else if (this.filters.region){
        planta = this.id;
      } else {
        region = this.id;
      }

      const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?year=${this.filters.year}&period=${this.filters.period}&plant=${planta}&region=${region}&technique=${this.online ? '' : this.filters.technique}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&feedback_status=${feedback}&area_id=${area_id}&online=${this.online}`

      let grid = {
        totalDados: event.point.y,
        title: NAME_CHART,
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
            "rows": '',
            "plant": this.$t("310"),
            "area": this.$t("311"),
            "sector": this.$t("312"),
            "component": this.$t("313"),
            "component_tag": this.$t("314"),
            "component_type_en": this.$t("315"),
            "machine": this.$t("316"),
            "machine_tag": this.$t("317"),
            "status_txt_en": this.$t("318"),
            "report_number": this.$t("319"), 
            "approved_datetime": this.$t("320"),
            "technique_en": this.$t("321"),
            "feedback_status_en" : this.$t("333"),
            "link": this.$t("323"),
            "link_rci": this.$t("324")
        },
        show: true,
        titleHelp: 'Grid - ' + this.$t("354"),
        txtHelp: this.$t("355")
      }

      if (this.filters.plant) {
          delete grid.columns['plant']
      } 

      this.changeGrid(grid);

    },
    ...mapMutations(['changeGrid']),
  },
  mounted: function() {
    if (this.pendente == 0 && this.programado == 0){
      this.chartOptions.series[0].data = [{name: 'No data', y: 100, color: 'transparent'}];
      this.chartOptions.plotOptions.pie.borderWidth = 1;
      // this.chartOptions.title.text = '';
      this.chartOptions.plotOptions.pie.cursor = '';
      this.$refs.chart.chart.redraw();
    }
  },
  props: {
    title: {
      type: String,
    },
    pendente: {
      type: Number,
    },
    programado: {
      type: Number,
    },
    id: {
      type: String
    },
    filters:{
      type: Object
    },
    online: {
      type: Number,
      default: 0
    }
  },
}
</script>
<style scoped>
tspan {
  stroke: none!important;
  stroke-width: 1px;
  stroke-linejoin: round;
  /* font-size: 23px !important; */
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}
div[data-popover="helpresult"] {
  left: 85% !important;
}

.content-1 {
  /* background: #1E1E1E; */
  border-radius: 0;
  color: #5b5b5b;
  margin-bottom: 20px;
  min-height: 30px;
  position: relative;
  /* -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08); */
  /* -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08); */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08); */
}

.chart-content-div{
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}

.chart-content-div-header {
  /* padding: 0 0 0 15px; */
  text-align: center
}

.chart-content-div-header h4{
  margin-top: -4px;
}

.chart-content-div-header h4 small{
  color: #ffffff;
}
.my-export{
  padding-right: 10px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/Donut.vue